import React from "react";
import { MotionModal, ModalCloseButton } from "../motion";

// Form popup used by the quotation page (client information).
// Widths match the Bootstrap classes it used before (modal-sm + modal-xl):
// full width on phones, 300px from 576px, 800px from 992px, 1140px from 1200px.
const ModalForm = ({
    show,
    children,
    onClose,
    title,
    description
}) => {
    return (
        <MotionModal
            show={show}
            onClose={onClose}
            labelledBy="modalTitleId"
            maxWidthClassName="tw:sm:max-w-[300px] tw:lg:max-w-[800px] tw:xl:max-w-[1140px]"
            panelClassName="border-top-gold"
        >
            <div className="modal-body">
                <div className="d-flex justify-content-end">
                    <ModalCloseButton isInline onClick={onClose} />
                </div>
                <h3 id="modalTitleId" className="text-center">
                    {title}
                </h3>
                <p className="text-center mt-2 fs-13">
                    {description}
                </p>
                {children}
            </div>
        </MotionModal>
    )
}

export default ModalForm;
